(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dispro-feedback-form"]) return;
  try {
    
  (function () {
    var VALID_RATINGS = ['1', '2', '3'];
    var STORAGE_KEY = 'dispro-feedback-rating';

    function readStoredRating() {
      try {
        return window.sessionStorage.getItem(STORAGE_KEY);
      } catch (error) {
        return null;
      }
    }

    function writeStoredRating(value) {
      try {
        if (value) {
          window.sessionStorage.setItem(STORAGE_KEY, value);
        } else {
          window.sessionStorage.removeItem(STORAGE_KEY);
        }
      } catch (error) {
        /* opslag niet beschikbaar: geen probleem */
      }
    }

    function initFeedbackForm(form) {
      if (form.getAttribute('data-feedback-ready') === 'true') return;
      form.setAttribute('data-feedback-ready', 'true');

      var success = form.querySelector('[data-feedback-success]');
      if (success) {
        writeStoredRating(null);
        success.focus();
        return;
      }

      var rating = new URLSearchParams(window.location.search).get('rating');
      if (VALID_RATINGS.indexOf(rating) !== -1) {
        writeStoredRating(rating);
      } else {
        rating = readStoredRating();
        if (VALID_RATINGS.indexOf(rating) === -1) rating = null;
      }

      var ratingField = form.querySelector('[data-feedback-rating]');
      if (ratingField && rating) {
        ratingField.value = rating + ' van 5 sterren';
      }

      var message = form.querySelector('[data-feedback-message]');
      var error = form.querySelector('[data-feedback-error]');
      if (!message || !error) return;

      var baseDescribedBy = message.getAttribute('aria-describedby') || '';
      var errorText = error.textContent.replace(/\s+/g, ' ').trim();

      function updateValidity() {
        var isEmpty = message.value.trim() === '';
        message.setCustomValidity(isEmpty ? errorText : '');
        return !isEmpty;
      }

      function showError(show) {
        error.hidden = !show;
        if (show) {
          message.setAttribute('aria-invalid', 'true');
          message.setAttribute('aria-describedby', (error.id + ' ' + baseDescribedBy).trim());
        } else {
          message.removeAttribute('aria-invalid');
          message.setAttribute('aria-describedby', baseDescribedBy);
        }
      }

      updateValidity();

      message.addEventListener('input', function () {
        if (updateValidity() && !error.hidden) showError(false);
      });

      message.addEventListener('invalid', function (event) {
        event.preventDefault();
        showError(true);
        message.focus();
      });
    }

    function initAll() {
      document.querySelectorAll('[data-dispro-feedback="form"]').forEach(initFeedbackForm);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-homepage"] && !Shopify.designMode) return;
  try {
    
  class DisproCompleteSection {
    constructor(section) {
      if (!section || section.dataset.initialized === 'true') return;

      section.dataset.initialized = 'true';
      this.section = section;
      this.carousel = section.querySelector('[data-carousel]');
      this.previous = section.querySelector('[data-previous]');
      this.next = section.querySelector('[data-next]');
      this.video = section.querySelector('video');

      this.initializeCarousel();
      this.initializeVideo();
    }

    initializeCarousel() {
      if (!this.carousel) return;

      this.previous?.addEventListener('click', () => this.scrollCarousel(-1));
      this.next?.addEventListener('click', () => this.scrollCarousel(1));

      this.carousel.addEventListener(
        'scroll',
        () => this.updateButtons(),
        { passive: true }
      );

      window.addEventListener(
        'resize',
        () => this.updateButtons(),
        { passive: true }
      );

      this.updateButtons();
    }

    scrollCarousel(direction) {
      const card = this.carousel.querySelector('.dispro-complete__card');

      if (!card) return;

      const gap = parseFloat(
        getComputedStyle(this.carousel).columnGap
      ) || 0;

      const distance =
        card.getBoundingClientRect().width + gap;

      this.carousel.scrollBy({
        left: distance * direction,
        behavior: 'smooth'
      });
    }

    updateButtons() {
      if (!this.carousel) return;

      const maximum =
        this.carousel.scrollWidth -
        this.carousel.clientWidth;

      const current =
        Math.abs(this.carousel.scrollLeft);

      if (this.previous) {
        this.previous.disabled = current <= 2;
      }

      if (this.next) {
        this.next.disabled =
          current >= maximum - 2;
      }
    }

    initializeVideo() {
      if (!this.video) return;

      this.video.muted = true;
      this.video.autoplay = true;
      this.video.playsInline = true;

      this.video.setAttribute('muted', '');
      this.video.setAttribute('autoplay', '');
      this.video.setAttribute('playsinline', '');

      const attemptPlay = () => {
        const playPromise = this.video.play();

        if (playPromise !== undefined) {
          playPromise.catch(() => {});
        }
      };

      if (this.video.readyState >= 2) {
        attemptPlay();
      } else {
        this.video.addEventListener(
          'loadeddata',
          attemptPlay,
          { once: true }
        );
      }

      this.videoObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (
              entry.isIntersecting &&
              entry.intersectionRatio >= 0.2
            ) {
              attemptPlay();
            } else {
              this.video.pause();
            }
          });
        },
        {
          threshold: [0, 0.2, 0.6]
        }
      );

      this.videoObserver.observe(this.video);
    }
  }

  const initializeDisproCompleteSections = (
    scope = document
  ) => {
    scope
      .querySelectorAll('[data-dispro-complete]')
      .forEach((section) => {
        new DisproCompleteSection(section);
      });
  };

  initializeDisproCompleteSections();

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initializeDisproCompleteSections(event.target);
    }
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  class DisproInstallationVideo {
    constructor(section) {
      if (!section || section.dataset.initialized === 'true') {
        return;
      }

      section.dataset.initialized = 'true';

      this.section = section;
      this.video = section.querySelector('video');
      this.media = section.querySelector(
        '.dispro-installation-video__media'
      );

      this.handlePause = this.handlePause.bind(this);
      this.handleVisibilityChange =
        this.handleVisibilityChange.bind(this);
      this.preventContextMenu =
        this.preventContextMenu.bind(this);

      this.initializeVideo();
    }

    playVideo() {
      if (!this.video) {
        return;
      }

      this.video.muted = true;
      this.video.defaultMuted = true;

      const playPromise = this.video.play();

      if (playPromise !== undefined) {
        playPromise.catch(() => {
          /*
            Sommige browsers blokkeren autoplay tijdelijk.
            Zodra de pagina weer actief wordt, wordt opnieuw
            geprobeerd de video te starten.
          */
        });
      }
    }

    handlePause() {
      /*
        Wanneer de video door een browser of een andere actie
        wordt gepauzeerd, wordt hij direct opnieuw gestart.
      */
      if (document.visibilityState === 'visible') {
        this.playVideo();
      }
    }

    handleVisibilityChange() {
      /*
        Wanneer iemand teruggaat naar het tabblad,
        begint de video automatisch weer te spelen.
      */
      if (document.visibilityState === 'visible') {
        this.playVideo();
      }
    }

    preventContextMenu(event) {
      event.preventDefault();
    }

    initializeVideo() {
      if (!this.video) {
        return;
      }

      this.video.muted = true;
      this.video.defaultMuted = true;
      this.video.autoplay = true;
      this.video.loop = true;
      this.video.playsInline = true;
      this.video.controls = false;
      this.video.playbackRate = 1;

      /*
        Extra browserfuncties uitschakelen.
      */
      this.video.disablePictureInPicture = true;
      this.video.disableRemotePlayback = true;

      this.video.setAttribute('muted', '');
      this.video.setAttribute('autoplay', '');
      this.video.setAttribute('loop', '');
      this.video.setAttribute('playsinline', '');
      this.video.setAttribute('webkit-playsinline', '');
      this.video.setAttribute('tabindex', '-1');

      this.video.setAttribute(
        'controlslist',
        'nodownload nofullscreen noplaybackrate noremoteplayback'
      );

      this.video.setAttribute(
        'disablepictureinpicture',
        ''
      );

      this.video.setAttribute(
        'disableremoteplayback',
        ''
      );

      this.video.removeAttribute('controls');

      /*
        Voorkomt dat de afspeelsnelheid aangepast blijft.
      */
      this.video.addEventListener('ratechange', () => {
        if (this.video.playbackRate !== 1) {
          this.video.playbackRate = 1;
        }
      });

      /*
        Automatisch opnieuw afspelen wanneer de video
        gepauzeerd raakt.
      */
      this.video.addEventListener(
        'pause',
        this.handlePause
      );

      /*
        Rechtermuisknop en contextmenu uitschakelen.
      */
      this.video.addEventListener(
        'contextmenu',
        this.preventContextMenu
      );

      if (this.media) {
        this.media.addEventListener(
          'contextmenu',
          this.preventContextMenu
        );
      }

      document.addEventListener(
        'visibilitychange',
        this.handleVisibilityChange
      );

      /*
        Video starten zodra er voldoende videodata is.
      */
      if (this.video.readyState >= 2) {
        this.playVideo();
      } else {
        this.video.addEventListener(
          'loadeddata',
          () => {
            this.playVideo();
          },
          { once: true }
        );
      }

      /*
        Extra poging bij het laden van de metadata.
      */
      this.video.addEventListener(
        'loadedmetadata',
        () => {
          this.playVideo();
        },
        { once: true }
      );

      /*
        Wanneer de video onverhoopt eindigt,
        opnieuw vanaf het begin starten.
      */
      this.video.addEventListener('ended', () => {
        this.video.currentTime = 0;
        this.playVideo();
      });
    }

    destroy() {
      if (!this.video) {
        return;
      }

      this.video.removeEventListener(
        'pause',
        this.handlePause
      );

      this.video.removeEventListener(
        'contextmenu',
        this.preventContextMenu
      );

      if (this.media) {
        this.media.removeEventListener(
          'contextmenu',
          this.preventContextMenu
        );
      }

      document.removeEventListener(
        'visibilitychange',
        this.handleVisibilityChange
      );

      delete this.section.disproInstallationVideoInstance;
      delete this.section.dataset.initialized;
    }
  }

  const initializeDisproInstallationVideos = (
    scope = document
  ) => {
    scope
      .querySelectorAll(
        '[data-dispro-installation-video]'
      )
      .forEach((section) => {
        if (
          !section.disproInstallationVideoInstance
        ) {
          section.disproInstallationVideoInstance =
            new DisproInstallationVideo(section);
        }
      });
  };

  initializeDisproInstallationVideos();

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initializeDisproInstallationVideos(
        event.target
      );
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    (event) => {
      const section = event.target.querySelector(
        '[data-dispro-installation-video]'
      ) || (
        event.target.matches &&
        event.target.matches(
          '[data-dispro-installation-video]'
        )
          ? event.target
          : null
      );

      if (
        section &&
        section.disproInstallationVideoInstance
      ) {
        section.disproInstallationVideoInstance.destroy();
      }
    }
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whats-included"] && !Shopify.designMode) return;
  try {
    
  class DisproCompleteSection {
    constructor(section) {
      if (!section || section.dataset.initialized === 'true') return;

      section.dataset.initialized = 'true';
      this.section = section;
      this.carousel = section.querySelector('[data-carousel]');
      this.previous = section.querySelector('[data-previous]');
      this.next = section.querySelector('[data-next]');
      this.video = section.querySelector('video');

      this.initializeCarousel();
      this.initializeVideo();
    }

    initializeCarousel() {
      if (!this.carousel) return;

      this.previous?.addEventListener('click', () => this.scrollCarousel(-1));
      this.next?.addEventListener('click', () => this.scrollCarousel(1));
      this.carousel.addEventListener('scroll', () => this.updateButtons(), { passive: true });
      window.addEventListener('resize', () => this.updateButtons(), { passive: true });

      this.updateButtons();
    }

    scrollCarousel(direction) {
      const card = this.carousel.querySelector('.dispro-complete__card');

      if (!card) return;

      const gap = parseFloat(getComputedStyle(this.carousel).columnGap) || 0;
      const distance = card.getBoundingClientRect().width + gap;

      this.carousel.scrollBy({
        left: distance * direction,
        behavior: 'smooth'
      });
    }

    updateButtons() {
      if (!this.carousel) return;

      const maximum = this.carousel.scrollWidth - this.carousel.clientWidth;
      const current = Math.abs(this.carousel.scrollLeft);

      if (this.previous) {
        this.previous.disabled = current <= 2;
      }

      if (this.next) {
        this.next.disabled = current >= maximum - 2;
      }
    }

    initializeVideo() {
      if (!this.video) return;

      this.video.muted = true;
      this.video.setAttribute('muted', '');
      this.video.setAttribute('playsinline', '');

      this.videoObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.35) {
              const playPromise = this.video.play();

              if (playPromise !== undefined) {
                playPromise.catch(() => {});
              }
            } else {
              this.video.pause();
            }
          });
        },
        {
          threshold: [0, 0.35, 0.75]
        }
      );

      this.videoObserver.observe(this.video);
    }
  }

  const initializeDisproCompleteSections = (scope = document) => {
    scope.querySelectorAll('[data-dispro-complete]').forEach((section) => {
      new DisproCompleteSection(section);
    });
  };

  initializeDisproCompleteSections();

  document.addEventListener('shopify:section:load', (event) => {
    initializeDisproCompleteSections(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
